<template>
  <div>
    <!-- 业务页签账单详情弹出框 -->
    <el-dialog
      id="app"
      v-el-drag-dialog
      :visible.sync="innerVisible"
      :title="requestSource === 'booking' ? $t('CargoMsg.Cargo_DomesticBill') : $t('Message.Bill')"
      :fullscreen="!isBpm"
      :width="isBpm ? '1640px' : 'auto'"
      :close-on-press-escape="false"
      :modal-append-to-body="false"
      :close-on-click-modal="false"
      class="bill-dialog"
    >
      <div :style="'min-width: 1600px;' + (expandedGrid || !showBillForm ? 'height: 100%;display: flex;flex-direction: column;' : '')">
        <!--账单详情表单-->
        <div
          v-show="!expandedGrid"
          class="app-main-inner-row bill-dialog-form-wrapper"
        >
          <bill-form
            v-if="showBillForm"
            ref="billForm"
            :billing="billing"
            :billing-form-params="billingFormParams"
            :is-view="isView"
            :request-source="requestSource"
            :create-bill-way="createBillWay"
            :accounts="accounts"
            @calculateAmount="calculateAmount"
            @currencyChangeEvent="currencyChangeEvent"
            @accountIdChange="onAccountIdChange"
            @refreshOtherBillingData="otherBillingData"
          />
        </div>
        <div class="app-main-inner-row" style="justify-content: center;font-size:30px;">
          <i :class="expandedGrid?'el-icon-caret-bottom':'el-icon-caret-top'" @click="expandedGrid=!expandedGrid" />
        </div>
        <div class="app-main-inner-row" style="justify-content: space-between">
          <div>
            <el-button
              v-if="!isView"
              type="primary"
              @click="addBillChargeEvent"
            >{{ this.$t('SeaExport.AddBillCharge') }}</el-button>
            <el-button
              v-if="!isView"
              type="primary"
              @click="removeBillChargeEvent"
            >{{ this.$t('SeaExport.RemoveBillCharge') }}</el-button>
            <el-checkbox v-show="!isView && chkShowLclVisible" v-model="chkShowLclSelected" style="margin-left: 10px;" @change="chkChangeHandler">{{ $t('SeaExport.ShowLcl') }}</el-checkbox>
            <!-- 指令操作按钮 -->
            <template v-for="(item, index) in instructionBtns">
              <el-button
                :key="index"
                :no="item.platformInstructionRuleCode"
                :type="getInstructionBtnType(item)"
                :disabled="!item.allowOperate || isView"
                :style="{marginLeft: index === 0 ? '5px' : ''}"
                @click="onInstructionClick(item)"
              >
                {{ getInstructionLabel(item) }}
              </el-button>
            </template>
          </div>
        </div>
        <div class="app-main-inner-row" style="justify-content: space-between">
          <div v-show="isView" class="section">
            <el-radio-group v-model="reconciliationType" no="reconciliationMode" @change="reconciliationTypeChangeHandler">
              <el-radio no="viewedByJob" label="job">{{ $t('CargoMsg.Cargo_ViewedByJob') }}</el-radio>
              <el-radio no="viewedByFee" label="charge" style="margin-right:10px">{{ $t('CargoMsg.Cargo_ViewedByFee') }}</el-radio>
            </el-radio-group>
          </div>
        </div>
        <div class="app-main-inner-row row-grid" :style="expandedGrid||!showBillForm?'flex-grow: 1;':'height:300px'">
          <cargo-ag-grid
            :config-module="reconciliationType === 'job'?'1301262':'1301251'"
            :grid-options="gridOptions"
            :column-defs="columnDefs"
            :row-data="rowData"
            :style="{width:'100%',height:'auto'}"
            @gridReady="params=>{gridApi=params.api}"
          />
        </div>

        <!--加入费用-->
        <join-charge-dialog
          v-if="showJoinChargeDialog"
          :visible.sync="showJoinChargeDialog"
          :search-item-module="searchItemModule"
          :default-conditions="addChargeCondition"
          @addChargeCallBackEvent="addChargeCallBackEvent"
        />

        <!--冲突费用明细弹出框-->
        <conflict-charges-dialog
          v-if="showConflictChargeDialog"
          :visible.sync="showConflictChargeDialog"
          :charges="conflictCharges"
          view-source="billingDetail"
          @conflictChargeCallBackEvent="conflictChargeCallBackEvent"
        />

      </div>
      <div v-if="!isBpm" slot="footer">
        <span v-if="isNew" style="position: absolute; left: 0; padding-left: 10px;">
          <el-checkbox v-model="defaultContent" no="invoice_sp30">{{ $t('Invoice.invoice_sp30') }}</el-checkbox>
        </span>
        <el-button v-permission="['button_InternalBillInfo_invoiceFromBilling']" :disabled="applyInvoiceDisabled || isBpm" type="primary" @click="onApplyInvoiceClick(billing)">{{ $t('Billing.ApplyForInvoicing') }}</el-button>
        <!--      <el-button-->
        <!--        v-if="!isView && billing.state === 0"-->
        <!--        type="primary"-->
        <!--        @click="saveBillingDetail(true)"-->
        <!--      >{{ $t('CargoMsg.Cargo_SaveAndConfirm') }}</el-button>-->
        <el-button
          v-if="!isView"
          type="primary"
          @click="saveBilling(false)"
        >{{ $t('SeaExport.Save') }}</el-button>
        <el-button :disabled="isBpm" @click="innerVisible=false">{{ $t('SeaExport.Cancel') }}</el-button>
      </div>
      <template v-if="isBpm" slot="footer" style="height: 65px">
        <approval-comments-and-btns
          v-if="isBpm"
          :process-info="processInfo"
          :records="records"
          :type="type"
          :form-subtype="MAKE_INVOICE_BILLING.code"
          :application-dimension="APPLICATION_DIMENSION_BILL.code"
          :dashboard-url="dashboardUrl"
          @close="$emit('close')"
          @closeAndRefresh="$emit('closeAndRefresh')"
        />
      </template>
    </el-dialog>

    <!-- 多条业务 配置规则验证弹窗 -->
    <batch-checking-window
      v-if="batchCheckingWindow.visible"
      :visible.sync="batchCheckingWindow.visible"
      :lob="batchCheckingWindow.lob"
      :jobs="batchCheckingWindow.jobs"
      :check-node="batchCheckingWindow.checkNode"
      :call-back="batchCheckingWindow.callBack"
      :call-back2="batchCheckingWindow.callBack2"
    />
    <!-- 账单保存校验弹窗 -->
    <checking-save-job-window
      v-if="checkingSaveJobWindow.visible"
      :visible.sync="checkingSaveJobWindow.visible"
      :lob="checkingSaveJobWindow.lob"
      :row-data="checkingSaveJobWindow.rowData"
      :check-node="checkingSaveJobWindow.checkNode"
      :call-back="checkingSaveJobWindow.callBack"
    />
    <!-- 账单编辑费用弹窗 -->
    <bill-edit-charge-dialog
      v-if="billEditChargeDialog.visible"
      :visible.sync="billEditChargeDialog.visible"
      :title="billEditChargeDialog.title"
      :simple-jobs="billEditChargeDialog.simpleJobs"
      :job="job"
      :charge="billEditChargeDialog.charge"
      :currency-list="billEditChargeDialog.currencyList"
      :billing="billing"
      @callback="saveBillEditChargeCallback"
    />
  </div>
</template>

<script>

import BillForm from './billForm'
import { getBillingDetail } from '@/api/clearing/billingNative'
import * as BillingConstants from '@/class/cargo/model/parameters/BillingConstants'
import { Billing } from '@/class/model/act/Billing'
import StrUtils from '@/utils/StrUtils'
import joinChargeDialog from '@/components/Cargo/Act/joinChargeDialog'
import ColumnUtils from '@/utils/ColumnUtils'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { loadChargeOfBilling, loadJobOfBilling, checkPartyBillingNoExist } from '@/api/clearing/billingNative'
import BillDetailHp from '@/components/Cargo/Act/billDetailHp'
import { cache, cacheName } from '@/utils/cacheManager'
import ApprovalCommentsAndBtns from '@/components/Cargo/Common/Wrokflow/approvalCommentsAndBtns'
import LocalStorageUtilsNew from '@/utils/localStorageUtilsNew'
import { APPLICATION_DIMENSION_BILL, MAKE_INVOICE_BILLING } from '@/class/cargo/model/parameters/WorkflowConstants'
import { queryInvoiceGoodsName } from '@/api/clearing/invoiceGoodsName'
import { jumpFinaceOrBusiness } from '@/components/Cargo/grid/routerAndPrintHelp'
import * as CheckRuleConstants from '@/class/cargo/model/parameters/CheckRuleConstants'
import { JobUtils } from '@/class/cargo/model/utils/JobUtils'
import BatchCheckingWindow from '@/components/Cargo/Job/CheckingManager/BatchCheckingWindow.vue'
import * as BillingUtils from '@/class/cargo/model/utils/BillingUtils'
import { getDashboardUrl } from '@/api/sysManage/businessIntelligence/businessIntelligenceDashboard'
import checkingSaveJobWindow from '@/components/Cargo/Job/CheckingManager/CheckingSaveJobWindow.vue'
import { checkChargeByBillingSaveNode } from '@/api/booking/job'
import { getLoading } from '@/utils/utilBaseElement'
import BillEditChargeDialog from '@/components/Cargo/Act/billEditChargeDialog'
import { Charge } from '@/class/model/act/Charge'
import ChargeUtils from '@/class/cargo/model/utils/ChargeUtils'
import BookingUtil from '@/class/cargo/model/utils/BookingUtil'
import { getChargeByUuid } from '@/api/clearing/charge'
import { AutoIncrementNum } from '@/utils/commonUtil'
import { Job } from '@/class/model/booking/Job'

export default {
  name: 'BillDialog',
  components: {
    checkingSaveJobWindow,
    BatchCheckingWindow,
    BillForm,
    joinChargeDialog, // 加入费用弹窗
    ApprovalCommentsAndBtns,
    BillEditChargeDialog
  },
  props: {
    visible: { type: Boolean, required: true },
    rType: { type: String, default: 'charge' },
    billingUuid: { type: String, required: true },
    isView: { type: Boolean, required: true },
    newBilling: { type: Object },
    newCharges: { type: Array },
    currentBillingBranchId: { type: Number },
    departmentTeamUser: { type: Array },
    isBpm: { type: Boolean, default: false }, // 审批事项-双击时-值为true（bpm使用）
    processInfo: { type: Object, default: () => {} }, // 审核流程
    type: { type: String, default: () => '' }, // apply-申请，look-查看，approve-审批
    records: { type: Array, default: () => [] }, // 审核记录
    createBillWay: { type: Number, default: 0 }, // 创建账单方式【0：结算对象 1、结算代理】
    accounts: { type: Array, default: () => [] }, // 结算对象
    location: { type: String, required: false },
    showWhtTax: { type: Boolean, default: false },
    job: { type: Object, default: () => {} },
    viewType: { type: Number, default: 0 }, // 费用查看方式
    lastProcessNode: { type: Object, default: () => {} }, // 最新节点
    slaveCharges: { type: Array, default: () => [] },
    instructionBtns: { type: Array, default: () => [] }
  },
  data() {
    return {
      dashboardUrl: '', // 仪表盘url
      selectTypeNames: TYPE_NAMES,
      billDetailHp: new BillDetailHp(this),
      innerVisible: false,
      reconciliationType: 'charge',
      showConflictChargeDialog: false, // 费用冲突显示弹出窗
      conflictCharges: [], // 账单保存时有冲突的费用集合
      showJoinChargeDialog: false,
      searchItemModule: '5042',
      addChargeCondition: {
        // 点击加入费用按钮时传递的参数
        exceptKeys: [],
        hasBillPayment: -1,
        hasBilling: -1,
        oversea: -1,
        accountId: 0
      },
      isShowCounterPartyBillingNo: false, // 是否展示代理账单号
      expandedGrid: false,
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        context: {
          componentParent: this
        },
        getRowStyle: function(params) {
          const data = params.data
          if (data) {
            if (data.hasOwnProperty('chargeVerifiedAmount')) {
              return (data.chargeConfirmState > 0 || data.chargeVerifiedAmount !== 0) ? { background: '#999999' } : { background: 'white' }
            } else {
              return data.chargeConfirmState > 0 ? { background: '#999999' } : { background: 'white' }
            }
          }
        }
      },
      gridParams: {},
      gridApi: null,
      rowData: [],
      billing: {
        uuid: '',
        version: 1,
        billingNo: '',
        accountId: 0,
        settlementAgentId: 0,
        buyerAddress: '',
        buyerTaxAccount: '',
        buyerTelephone: '',
        buyerBank: '',
        buyerBankAccount: '',
        ar: false,
        bankAccountId: 0,
        inputDate: '',
        dueDate: '',
        billingType: '',
        currency: '',
        sourceCurrency1: '',
        sourceCurrency2: '',
        sourceCurrency3: '',
        sourceRate1: 0.0,
        sourceRate2: 0.0,
        sourceRate3: 0.0,
        amount1: 0.0,
        amount2: 0.0,
        amount3: 0.0,
        remark: '',
        invoiceDemand: '',
        state: 0,
        amount: 0.0,
        taxAmount: 0.0,
        title: '',
        bankAccount: '',
        taxFreeAmount: 0.0, // 不含税额虚拟字段，用于逻辑处理
        counterPartyBillingNo: '',
        chargeCurrency1: '',
        chargeCurrency2: '',
        chargeRate1: 0.0,
        chargeRate2: 0.0,
        billingGroupUuid: '',
        removedCharges: [], // 删除掉的费用
        updateCharges: [], // 更新的费用
        createCharges: [], // 新增的费用
        currentOfficeId: 0,
        settlement: '', // 结算对象虚拟字段，结算代理改变时，结算对象也要发生变更
        createBillWay: 0,
        makeInvoiceType: 0,
        invoiceRemark: '',
        invoiceUsdRemark: '',
        remarkAddContent: '',
        detailMakeInvoice: 0,
        splitMakeInvoice: true
      },
      requestSource: 'booking', // 用于账单保存 标识 业务tab 入口保存账单
      billingFormParams: {
        // 账单详情页 相关信息数据(除账单以为的数据)
        sourceRate1Enable: true, // 第一行汇率是否可编辑，默认不可编辑
        sourceRate2Enable: true, // 第二行汇率是否可编辑，默认不可编辑
        sourceRate3Enable: true, // 第三行汇率是否可编辑，默认不可编辑}
        billingNoteContainInvoiceReques: 0, // 票开账单包含开票要求，开票时可以根据开票要求，直接开票
        goodsNames: [] // 发票增值税利率
      },
      showBillForm: false,
      searchConditions: {
        pageNum: 1,
        pageSize: 50,
        snapshotConditions: [] // 高级查询条件（点击查询时的快照状态）
      },
      batchCheckingWindow: {
        visible: false,
        jobs: [],
        checkNode: 0,
        callBack: null,
        callBack2: null,
        billDataList: []
      },
      checkingSaveJobWindow: {
        visible: false,
        rowData: [],
        lob: '',
        checkNode: 0,
        callBack: null
      },
      isSaveBillRate: false, // 是否使用账单汇率进行计算
      defaultContent: false, // 将本次内容设置为默认开票信息
      MAKE_INVOICE_BILLING: MAKE_INVOICE_BILLING,
      APPLICATION_DIMENSION_BILL: APPLICATION_DIMENSION_BILL,
      chkShowLclSelected: false,
      chkShowLclVisible: false, // 是否显示小票费用 checkbox
      billEditChargeDialog: {
        visible: false,
        title: '',
        simpleJobs: [],
        charge: {},
        currencyList: []
      },
      autoIncrementNum: new AutoIncrementNum(),
      jobChargeCache: new Map() // 业务费用缓存
    }
  },
  computed: {
    total() {
      return this.rowData.length || 0
    },
    applyInvoiceDisabled() {
      return !this.billingUuid || this.rowData.findIndex(p => p.needInvoice) < 0
    },
    isNew() {
      return StrUtils.isEmpty(this.billingUuid)
    },
    columnDefs() {
      let result = []
      if (this.reconciliationType === 'job') {
        result = [
          {
            headerName: '', checkboxSelection: true, width: 55,
            sortable: false, suppressMenu: true, suppressSizeToFit: true,
            resizable: false, headerCheckboxSelection: true
          },
          { headerName: this.$t('Billing.billingCharge_businessNumber'), field: 'jobJobNo', width: 150,
            cellRendererFramework: 'agGridColumnEdit',
            custom: {
              tag: 'multi-router-and-print',
              attrs: params => {
                const data = params.data
                return {
                  useRoute: true,
                  usePrint: false,
                  jumpMethod: value => {
                    jumpFinaceOrBusiness(this, value, '', data.chargeBranchId)
                    this.closeDialog()
                  }
                }
              }
            }
          },
          {
            headerName: this.$t('Billing.billingJob_customer'), field: 'jobCustomerId', initialWidth: 200,
            cellRenderer: (params) => {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'chineseName')
            }
          },
          { headerName: this.$t('Billing.billingCharge_mblNo'), field: 'jobMbl', initialWidth: 200 },
          { headerName: this.$t('Billing.billingJob_separateNumber'), field: 'jobImportHbl', initialWidth: 200 },
          { headerName: this.$t('Invoice.invoice_containerNo'),
            field: 'containerContainerNo',
            cellRenderer: (params) => {
              if (params.value) {
                if (params.value.indexOf(',') === 0) {
                  params.value = params.value.substring(1, params.value.length)
                } else if (params.value.substring(params.value.length - 1, params.value.length) === ',') {
                  params.value = params.value.substring(0, params.value.length - 1)
                }
              }
              return params.value
            },
            initialWidth: 200
          },
          {
            headerName: this.$t('Billing.billingCharge_carrier'), field: 'jobCarrierId', initialWidth: 200,
            cellRenderer: (params) => {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'chineseName')
            }
          },
          { headerName: this.$t('Billing.billingJob_vesselAndVoyageAndFlight'), field: 'jobVesselFlight', initialWidth: 200 },
          {
            headerName: this.$t('Billing.billingJob_portOfDischarge'), field: 'jobDischargingPortCode', initialWidth: 200,
            cellRenderer: (params) => {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Seaport, 'code', params.value, 'englishName')
            }
          },
          { headerName: 'SoNo', field: 'jobSoNo', initialWidth: 200 },
          { headerName: this.$t('Billing.billingJob_dateOfDeparture'), field: 'jobEtd', initialWidth: 200,
            cellRenderer: (params) => {
              return ColumnUtils.dateLabelFunc(params.value)
            }
          },
          {
            headerName: this.$t('Billing.billingJob_bookingAgent'), field: 'jobBookingAgent', initialWidth: 200,
            cellRenderer: (params) => {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'chineseName')
            }
          },
          {
            headerName: this.$t('Billing.billingCharge_operation'), field: 'jobOp', initialWidth: 200,
            cellRenderer: (params) => {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
            }
          },
          {
            headerName: this.$t('Billing.billingCharge_sales'), field: 'jobSales', initialWidth: 200,
            cellRenderer: (params) => {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
            }
          },
          {
            headerName: this.$t('Billing.billingJob_businessType'), field: 'jobLob', initialWidth: 200,
            cellRenderer: (params) => {
              return ColumnUtils.jobBussStateLabelFunc(params.value)
            }
          },
          { headerName: this.$t('Billing.billingCharge_currency'), field: 'jobChargeCurrency', initialWidth: 200 },
          {
            headerName: this.$t('Billing.billingJob_revenueAndExpenditureType'), field: 'jobAr', initialWidth: 200,
            cellRenderer: (params) => {
              return ColumnUtils.chargeReceivableLabelFun(params.value)
            }
          },
          {
            headerName: this.$t('Billing.billingJob_chargesTotalAmount'), field: 'jobChargeAmountTotal', initialWidth: 200,
            cellRenderer: (params) => {
              return ColumnUtils.numberColumnLabelFunc(params.value, 2)
            }
          }
        ]
      } else {
        result = [
          // 费用列表
          {
            headerName: '',
            checkboxSelection: true,
            width: 55,
            sortable: false,
            suppressMenu: true,
            suppressSizeToFit: true,
            resizable: false,
            headerCheckboxSelection: true
          },
          { headerName: this.$t('Billing.billingCharge_businessNumber'), field: 'jobJobNo', width: 150,
            cellRendererFramework: 'agGridColumnEdit',
            custom: {
              tag: 'multi-router-and-print',
              attrs: params => {
                const data = params.data
                return {
                  useRoute: true,
                  usePrint: false,
                  jumpMethod: value => {
                    jumpFinaceOrBusiness(this, value, '', data.chargeBranchId)
                    this.closeDialog()
                  }
                }
              }
            }
          },
          {
            headerName: this.$t('Billing.billingJob_mblNo'),
            field: 'jobMbl',
            width: 200
          },
          {
            headerName: this.$t('Billing.billingJob_vesselAndVoyageAndFlight'),
            field: 'jobVesselFlight',
            width: 200
          },
          {
            headerName: this.$t('Billing.billingJob_chargeItem'),
            field: 'chargeChargeItemId',
            width: 200,
            cellRenderer: (params) => {
              return ColumnUtils.resolveColumnLabel(
                TYPE_NAMES.basic_data_ChargeItem,
                'itemId',
                params.value,
                'zhName'
              )
            }
          },
          {
            headerName: this.$t('Billing.billingJob_paymentType'),
            field: 'chargeReceivable',
            width: 200,
            cellRenderer: (params) => {
              return ColumnUtils.chargeReceivableLabelFun(params.value)
            }
          },
          {
            headerName: this.$t('Billing.billingForm_collectAndPrepaidOrNot'),
            field: 'chargeAdvance',
            width: 200,
            cellRenderer: (params) => {
              return ColumnUtils.booleanLabelFunction(params.value)
            }
          },
          {
            headerName: this.$t('Billing.billingJob_currency'),
            field: 'chargeCurrency',
            width: 200
          },
          {
            headerName: this.$t('Billing.billingForm_unit'),
            field: 'chargeMeasure',
            width: 200,
            cellRenderer: (params) => {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_ChargeUnit, 'code', params.value, 'chineseName')
            }
          },
          {
            headerName: this.$t('Billing.billingJob_amount'),
            field: 'chargeQuantity',
            width: 200
          },
          {
            headerName: this.$t('Billing.billingJob_unitPrice'),
            field: 'chargeUnitRate',
            width: 200
          },
          {
            headerName: this.$t('Billing.billingJob_taxIncludedPrice'),
            field: 'chargeAmount',
            width: 200
          },
          {
            headerName: this.$t('Billing.billingJob_taxExcludedPrice'),
            field: 'chargeExcludingTaxAmount',
            width: 200
          },
          {
            headerName: this.$t('Billing.billingJob_taxRate'),
            field: 'chargeTaxRate',
            width: 200
          },
          {
            headerName: this.$t('Billing.billingJob_taxAmount'),
            field: 'chargeTaxAmount',
            width: 200
          },
          {
            headerName: this.$t('Billing.billingJob_separateNumber'),
            field: 'jobHbl',
            width: 200,
            hide: true
          },
          {
            headerName: this.$t('Billing.billingJob_remarks'),
            field: 'chargeRemarks',
            width: 200
          },
          {
            headerName: this.$t('FinanceManage.charge_invoiceHeader'),
            field: 'chargeInvoiceTitle',
            hide: true,
            width: 100
          }, {
            headerName: this.$t('FinanceManage.international_settlementAgent'),
            field: 'chargeSettlementAgentId',
            hide: true,
            width: 150,
            cellRenderer: (params) => {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'chineseName')
            }
          },
          {
            headerName: this.$t('Billing.billingCharge_itemNo'),
            field: 'jobPono',
            hide: true,
            width: 200
          },
          {
            headerName: this.$t('CargoMsg.Cargo_Business_CustomerRefNo'),
            field: 'jobCustomerRefNo',
            width: 200
          },
          {
            headerName: this.$t('FinanceManage.charge_relatedContainerNo'),
            field: 'relationContainerNo',
            colId: 'relationContainerNo',
            width: 200,
            hide: true
          },
          {
            headerName: this.$t('FinanceManage.charge_confirmOrNot'),
            field: 'chargeConfirmState',
            colId: 'chargeConfirmState',
            width: 200,
            cellRenderer: (params) => {
              return ColumnUtils.booleanLabelFunction(params.value)
            }
          }
        ]
      }
      if (this.showWhtTax) {
        result.push({
          headerName: this.$t('FinanceManage.charge_whtTaxRate'),
          field: 'whtTaxRate',
          width: 100,
          valueFormatter: (params) => {
            return ColumnUtils.numberColumnLabelFunc(params.value, 2)
          }
        },
        {
          headerName: this.$t('FinanceManage.charge_whtTaxAmount'),
          field: 'whtTaxLocalAmount',
          width: 100,
          valueFormatter: (params) => {
            return ColumnUtils.numberColumnLabelFunc(params.value, 2)
          }
        }, {
          headerName: this.$t('FinanceManage.charge_notWhtAmount'),
          field: 'chargeNotWhtAmount',
          width: 200,
          valueFormatter: (params) => {
            return this.$numeral(params.value).format('0.00')
          }
        })
      }
      if (this.billingFormParams.billingNoteContainInvoiceReques) {
        result.push({
          headerName: this.$t('Billing.billingCharge_sales'), field: 'jobSales', initialWidth: 200,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_profitMargin'), field: 'profitMargin', width: 100
        },
        {
          headerName: this.$t('CargoMsg.Cargo_LinesArAp'), field: 'lineNumber', width: 100
        }, {
          headerName: this.$t('CargoMsg.Cargo_RInPay'), field: 'arIncludeAp', width: 100,
          cellRenderer: (params) => {
            return ColumnUtils.IsBookedLabelFunc(params.value)
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_GPExplain'), field: 'explainGp', width: 100
        })
      }
      return result
    },
    isBySettlementAgent() { // 按结算代理新增
      return this.createBillWay === 1 && !this.billing.uuid
    }
  },
  watch: {
    visible(newVal) {
      this.innerVisible = newVal
    },
    innerVisible(newVal) {
      this.$emit('update:visible', newVal)
      if (!newVal) {
        this.rowData = []
        this.jobChargeCache.clear()
      }
    }
  },
  created() {
    if (this.visible) {
      this.innerVisible = true
    }
  },
  async beforeMount() {
    this.onShow()
  },
  methods: {
    getInvoiceUuidsFromCharges(charges) {
      const keys = new Set()
      for (const c of (charges || [])) {
        if (c && c.needInvoice && !StrUtils.isEmpty(c.invoiceUuid)) {
          keys.add(c.invoiceUuid)
        }
      }
      return Array.from(keys)
    },
    hasUnInvoicedNeedInvoiceCharge(charges) {
      for (const c of (charges || [])) {
        if (c && c.needInvoice && StrUtils.isEmpty(c.invoiceUuid)) return true
      }
      return false
    },
    // If all "needInvoice" charges are already linked to invoices, jump to invoice detail instead of starting apply flow.
    onApplyInvoiceClick(billing) {
      const charges = this.rowData || []
      const invoiceUuids = this.getInvoiceUuidsFromCharges(charges)
      const hasUnInvoiced = this.hasUnInvoicedNeedInvoiceCharge(charges)
      if (!hasUnInvoiced && invoiceUuids.length > 0) {
        // Only emit if parent listens; otherwise keep legacy behavior.
        if (this.$listeners && this.$listeners.viewInvoice) {
          this.$emit('viewInvoice', invoiceUuids)
          return
        }
      }
      this.$emit('applyInvoice', billing)
    },
    async onShow() {
      await cache.load(cacheName.CONFIG)
      this.isSaveBillRate = Number(cache.config.get('isSaveBillRate')) === 1
      this.billingFormParams.eiTaxControlInterfaceName = String(cache.config.get('EITaxControlInterfaceName'))
      this.billingFormParams.billingNoteContainInvoiceReques = Number(cache.config.get('BillingNoteContainInvoiceReques'))
      this.billingFormParams.toExoSystemYGSH = String(cache.config.get('ToExoSystem')) === 'YGSH' // 阳光速航
      this.billingFormParams.newInvoiceTypesOfBilling = Number(cache.config.get('newInvoiceTypesOfBilling')) === 1
      this.reconciliationType = this.rType
      this.showLclCharge()
      // 数据初始化
      this.rowData = []
      this.billing = new Billing().fillDefaultValue().getData()
      // 编辑/查看 账单
      if (!StrUtils.isEmpty(this.billingUuid)) {
        this.queryBillingDetail()
      } else {
        // 新增账单
        this.billing = { ...this.newBilling }
        this.queryChargeOfBilling()
        this.showBillForm = true
      }
      this.queryInvoiceGoodsName()
    },
    // 查询账单详情
    queryBillingDetail() {
      getBillingDetail(this.billingUuid).then((res) => {
        this.billing = { ...res.data }
        this.billing.currentOfficeId = this.$store.getters.currentOfficeId // 当前分公司
        this.createBillWay = this.billing.createBillWay
        if (this.createBillWay === 1) {
          this.searchItemModule = '5044'
        }
        const billing = this.billing
        billing.removedCharges = []
        billing.createCharges = []
        billing.updateCharges = []
        billing.deletedChargeKeys = []
        this.isShowCounterPartyBillingNo = billing.billingType === BillingConstants.BILLING_TYPE_OVERSEA.code
        // 默认查询对账单关联的账单信息
        const uuid = billing.uuid
        if (uuid) {
          this.queryChargeOfBilling()
        }
        this.billDetailHp.querySettlement(billing.accountId)
        this.billDetailHp.checkBillingRateEditable()
        this.showBillForm = true

        // 判断是否配置仪表盘ID
        if (this.lastProcessNode && this.lastProcessNode.dashboardId && this.billing && this.billing.billingNo) {
          const paramsDashboard = {}
          paramsDashboard.anyInteger = this.lastProcessNode.dashboardId
          paramsDashboard.branchId = this.$store.getters.currentOfficeId
          paramsDashboard.anyStr = 'bill_no' // 参数名称
          paramsDashboard.anyStr1 = this.billing.billingNo // 参数值
          // paramsDashboard.anyStr2 = 'bill_uuid' // 参数名称
          // paramsDashboard.anyStr3 = this.billing.uuid // 参数值
          if (this.$store.getters.env !== 'prod') {
            // 方便测试
            paramsDashboard.anyStr1 = 'XGSH24100105D'
          }
          getDashboardUrl(paramsDashboard).then(res => {
            this.dashboardUrl = res.data
          })
        }
      })
    },
    // 查询账单关联的费用信息
    queryChargeOfBilling() {
      const requestBody = { branchId: 0, pageNum: this.searchConditions.pageNum, pageSize: this.searchConditions.pageSize, requestSource: 'BillingDetail_Charge', paging: false }
      if (this.billing.uuid) { // 针对于已经创建好的账单查询
        requestBody.billingKey = this.billing.uuid
      } else { // 针对于新增未保存的账单查询,根据费用UUID查询
        requestBody.chargeKeys = this.newCharges
      }
      requestBody.currentBillingBranchId = this.$store.getters.currentOfficeId
      loadChargeOfBilling(requestBody).then(async res => {
        if (res.data) {
          this.rowData = [...res.data.list]
        } else {
          this.rowData = []
        }
        if (StrUtils.isEmpty(this.billingUuid)) { // 针对于新增未保存的账单,重新计算账单金额等信息
          await this.billDetailHp.refreshBilling()
          this.chkChangeHandler()
          await this.otherBillingData()
        }
      })
    },
    // 查询账单关联的业务信息
    queryJobOfBilling() {
      const requestBody = { branchId: 0, pageNum: this.searchConditions.pageNum, pageSize: this.searchConditions.pageSize, requestSource: 'BillingDetail_Job', paging: false }
      if (this.billing.uuid) { // 针对于已经创建好的账单查询
        requestBody.billingKey = this.billing.uuid
      } else { // 针对于新增未保存的账单查询,根据费用UUID查询
        requestBody.chargeKeys = this.newCharges
      }
      requestBody.currentBillingBranchId = this.$store.getters.currentOfficeId
      loadJobOfBilling(requestBody).then(async res => {
        if (res.data.list && res.data.list.length > 0) {
          this.rowData = [...res.data.list]
          let charges = []
          for (let i = 0; i < res.data.list.length; i++) {
            const job = res.data.list[i]
            const jobCharges = job['charges']
            if (jobCharges && jobCharges.length > 0) {
              charges = charges.concat(jobCharges)
              // 对所有费用的chargeNotWhtAmount字段求和
              let totalNotWhtAmount = 0
              let totalWhtTaxLocalAmount = 0
              let totalWhtTaxRate = 0
              for (const charge of jobCharges) {
                totalWhtTaxRate += charge['whtTaxRate'] || 0
                totalWhtTaxLocalAmount += charge['whtTaxLocalAmount'] || 0
                totalNotWhtAmount += charge['chargeNotWhtAmount'] || 0
              }
              job['chargeNotWhtAmount'] = totalNotWhtAmount
              job['whtTaxLocalAmount'] = totalWhtTaxLocalAmount
              job['whtTaxRate'] = totalWhtTaxRate
            }
          }
        } else {
          this.rowData = []
        }
        // 新建账单时，加载费用明细后重新计算账单
        if (this.billing && !this.billing.uuid) {
          await this.billDetailHp.refreshBilling()
        }
      })
    },
    fetchDataByPage() {
      this.queryChargeOfBilling(this.billing.uuid)
    },
    // 加入费用
    addBillChargeEvent() {
      this.billDetailHp.addBillChargeEvent()
    },

    // 加入费用回调事件
    addChargeCallBackEvent(charges) {
      this.billDetailHp.addChargeCallBackEvent(charges)
      this.otherBillingData()
    },
    // 移除费用
    async removeBillChargeEvent() {
      this.billDetailHp.removeBillChargeEvent()
      this.otherBillingData()
    },
    // 费用冲突弹窗回调函数
    conflictChargeCallBackEvent(result) {
      this.billDetailHp.conflictChargeCallBackEvent(result)
    },
    async saveBilling(affirm) {
      // 判断是否开启验证规则
      await cache.load(cacheName.CONFIG)
      const useCheckRule = Number(cache.config.get('useCheckRule')) === 1
      if (this.requestSource === 'booking') {
        if (useCheckRule) {
          const checkNodeFlag = await JobUtils.hasCheckRuleCondition(true, CheckRuleConstants.NODE_SAVE_BILLING.code, this.$store.getters.currentOfficeId)
          if (checkNodeFlag) {
            // 执行校验并处理校验结果
            const result = await this.performBillingValidation()
            if (result && result.needShowDialog) {
              this.showBillingValidationDialog(result.data)
            } else {
              await this.saveBillingDetail(affirm)
            }
          } else {
            await this.saveBillingDetail(affirm)
          }
        } else {
          await this.saveBillingDetail(affirm)
        }
        return
      }
      if (useCheckRule) {
        const checkNodeFlag = await JobUtils.hasCheckRuleCondition(true, CheckRuleConstants.NODE_SAVE_BILLING.code, this.$store.getters.currentOfficeId)
        if (checkNodeFlag) {
          this.batchCheckingWindow.checkNode = CheckRuleConstants.NODE_SAVE_BILLING.code
          console.log('this.rowData ', this.rowData)
          this.rowData.forEach((item) => {
            item.lob = item.jobLob
            item.chargeUuid = item.uuid
            item.jobNo = item.jobJobNo
          })
          this.batchCheckingWindow.jobs = this.rowData
          this.batchCheckingWindow.lob = this.rowData[0].jobLob
          this.batchCheckingWindow.callBack = () => { this.saveBillingDetail(affirm) }
          this.batchCheckingWindow.callBack2 = null
          this.batchCheckingWindow.visible = true
        } else {
          await this.saveBillingDetail(affirm)
        }
      } else {
        await this.saveBillingDetail(affirm)
      }
    },
    // 执行账单校验
    async performBillingValidation() {
      // 调用实际的校验接口
      const requestData = {
        checkNode: CheckRuleConstants.NODE_SAVE_BILLING.code,
        chargeUuidList: this.rowData ? this.rowData.map(item => item.uuid) : [],
        branchId: this.$store.getters.currentOfficeId,
        billing: this.billing || {}
      }

      const loading = getLoading()
      const response = await checkChargeByBillingSaveNode(requestData).finally(
        () => loading.close()
      )
      if (response && response.data) {
        // 检查是否有校验失败的项
        const hasValidationErrors = this.checkValidationResult(response.data)

        return {
          needShowDialog: hasValidationErrors,
          data: response.data
        }
      }
    },

    // 检查校验结果是否有错误
    checkValidationResult(validationData) {
      if (!validationData) return false

      for (const key in validationData) {
        const rules = validationData[key]
        if (Array.isArray(rules)) {
          for (const rule of rules) {
            if (!rule.match && !rule.continueCheck) {
              return true // 有不匹配且不能继续的规则
            }
            if (!rule.match && rule.checkMode === 1) {
              return true // 有不匹配的错误级别规则
            }
          }
        }
      }
      return false
    },

    // 显示账单校验弹窗
    showBillingValidationDialog(validationData) {
      // 转换校验数据为CheckingSaveJobWindow组件需要的格式
      const convertedData = this.convertValidationDataForCheckingSaveJobWindow(validationData)

      this.checkingSaveJobWindow.checkNode = CheckRuleConstants.NODE_SAVE_BILLING.code
      this.checkingSaveJobWindow.rowData = convertedData
      this.checkingSaveJobWindow.callBack = this.saveBillingDetail
      this.checkingSaveJobWindow.visible = true
      this.checkingSaveJobWindow.lob = this.rowData[0].jobLob
    },

    // 转换校验数据格式以适配CheckingSaveJobWindow组件
    convertValidationDataForCheckingSaveJobWindow(validationData) {
      const result = []
      for (const key in validationData) {
        const rules = validationData[key]
        if (Array.isArray(rules)) {
          // 直接使用校验规则数据，CheckingSaveJobWindow会处理展示
          result.push(...rules)
        }
      }
      return result
    },
    // 保存账单
    async saveBillingDetail(affirm) {
      if (this.billing.counterPartyBillingNo) {
        const res = await checkPartyBillingNoExist({
          branchId: this.billing.branchId,
          billKey: this.billing.uuid,
          billingType: this.billing.billingType,
          counterPartyBillingNo: this.billing.counterPartyBillingNo
        })
        if (res.data) {
          const flag = await this.$confirm(this.$t('Billing.OppositeBillNoAlreadyExists'), this.$t('Message.Prompt'), {
            confirmButtonText: this.$t('common.btn.ok'),
            cancelButtonText: this.$t('common.btn.cancel'),
            dangerouslyUseHTMLString: true,
            closeOnClickModal: false,
            type: 'warning'
          }).then(() => true).catch(() => false)
          if (!flag) {
            return
          }
        }
      }
      if (this.billingFormParams.billingNoteContainInvoiceReques) {
        if (this.billing.remarkAddContent) {
          const r1 = this.billing.invoiceRemark.length
          const r2 = this.billing.remarkAddContent.length
          if (r1 + r2 > 230) {
            this.$message.warning(this.$t('CargoMsg.Cargo_RemarkTip1'))
            return
          }
        }
      }
      // 校验商务报价
      const businessMsg = await this.billDetailHp.checkCanSave()
      if (!StrUtils.isEmpty(businessMsg)) {
        this.$message.warning(businessMsg)
        return
      }

      // 校验开票抬头和结算代理
      const message = await this.billDetailHp.checkAgentAndTitle()
      let isSave = true
      if (!StrUtils.isEmpty(message)) {
        isSave = false
        await this.$confirm(message, this.$t('Message.Prompt'), {
          confirmButtonText: this.$t('common.btn.ok'),
          cancelButtonText: this.$t('common.btn.cancel'),
          distinguishCancelAndClose: true,
          type: 'warning'
        }).then(() => {
          isSave = true
        }).catch(() => {})
      }
      if (isSave) {
        this.billDetailHp.saveBillingDetail(affirm)
        // CARGO-39956，开票默认电子发票
        this.saveDefaultInvoiceContent()
        if (!this.billingUuid) {
          LocalStorageUtilsNew.setConfiguration('internal-showLclCharge', this.chkShowLclSelected)
        }
      }
    },
    // 计算账单金额等属性
    async calculateAmount() {
      this.billDetailHp.calculateAmount()
    },
    // 账单币种修改事件
    async currencyChangeEvent(currency) {
      this.billDetailHp.currencyChangeEvent(currency)
    },
    // 默认开票信息
    saveDefaultInvoiceContent() {
      if (!this.billing.uuid && this.defaultContent) {
        const item = {}
        item.invoiceMakeType = this.billing.invoiceMakeType || ''
        item.invoiceType = this.billing.invoiceType || ''
        LocalStorageUtilsNew.setConfiguration('invoceByNewBilling', item)
      }
    },
    onAccountIdChange() {
      this.chkChangeHandler()
    },
    /**
     * 是否显示小票费用
     */
    showLclCharge() {
      if (!this.billingUuid) {
        const showLclCharge = LocalStorageUtilsNew.getConfiguration('internal-showLclCharge')
        this.chkShowLclSelected = showLclCharge
      }
      if (this.job) { // 审批事项清单，点击详情进来时，job未传值
        this.chkShowLclVisible = this.job.masterFlag || false
      }
    },
    // 显示小票费用
    chkChangeHandler() {
      if (this.slaveCharges.length === 0) {
        return
      }
      const billing = this.billing
      const field = !this.isBySettlementAgent ? 'chargeAccountId' : 'chargeSettlementAgentId'
      const cmpIdx = !this.isBySettlementAgent ? billing.accountId : billing.settlementAgentId
      this.rowData = this.rowData.filter(p => !p.addedLcl)
      const chargeKeySet = new Set()
      for (const item of this.rowData) {
        chargeKeySet.add(item.uuid)
      }
      for (const charge of this.slaveCharges) {
        if (charge[field] === cmpIdx && (this.chkShowLclSelected ? true : charge.jobUuid === this.job.uuid)) {
          if (!chargeKeySet.has(charge.uuid)) {
            this.rowData.push({ ...charge, entity: 'charge', dirty: true, chargeBillingAmount: 0, billingUuid: billing.uuid, billingNo: billing.billingNo, addedLcl: true })
            chargeKeySet.add(charge.uuid)
          }
        }
      }
      this.billDetailHp.refreshInternalBillCharge()
    },
    async otherBillingData() {
      if (this.billingFormParams.billingNoteContainInvoiceReques) {
        await BillingUtils.setBillingInvoiceInformation(this.billing, this.rowData)
      }
    },
    queryInvoiceGoodsName() {
      if (this.billingFormParams.billingNoteContainInvoiceReques) {
        const requestBody = { 'officeId': this.$store.getters.currentOfficeId }
        queryInvoiceGoodsName(requestBody).then(res => {
          const list = res.data
          if (list && list.length > 0) {
            this.billingFormParams.goodsNames = list
          }
        })
      }
    },
    reconciliationTypeChangeHandler() {
      if (this.reconciliationType === 'job') {
        this.queryJobOfBilling()
      } else if (this.reconciliationType === 'charge') {
        this.queryChargeOfBilling()
      }
    },
    closeDialog() {
      this.innerVisible = false
    },
    getInstructionBtnType(item) {
      if (item.platformInstructionRuleCode === 'internalBillEdit' && item.instructionParamJson.editType === '删除费用') {
        return 'danger'
      }
      return 'primary'
    },
    getInstructionLabel(item) {
      if (item.platformInstructionRuleCode === 'internalBillEdit') {
        if (item.instructionParamJson.editType === '新增费用') {
          return this.$t('CargoMsg.Cargo_AddCharges')
        }
        if (item.instructionParamJson.editType === '编辑费用') {
          return this.$t('SeaExport.EditCharges')
        }
        if (item.instructionParamJson.editType === '删除费用') {
          return this.$t('CargoMsg.Cargo_DeleteFee')
        }
      }
      return this.$selectByLang(item.chineseName, item.englishName, item.japaneseName)
    },
    onInstructionClick(data) {
      if (data.platformInstructionRuleCode === 'internalBillEdit') {
        if (data.instructionParamJson.editType === '新增费用') {
          this.addBillCharge()
        }
        if (data.instructionParamJson.editType === '编辑费用') {
          this.editBillCharge()
        }
        if (data.instructionParamJson.editType === '删除费用') {
          this.removeBillCharge()
        }
      }
    },
    async addBillCharge() {
      const charge = new Charge().fillDefaultValue().getData()
      charge.currency = this.billing.currency
      charge.accountId = this.billing.accountId
      charge.settlementAgentId = this.billing.settlementAgentId
      charge.invoiceTitle = this.billing.title

      await BookingUtil.getNewCharge(charge, this.job, this.billing.ar)
      // 重新赋值，因为BookingUtil.getNewCharge会修改charge.accountId
      charge.accountId = this.billing.accountId

      await ChargeUtils.getChargeisOverseaNotControlledByConfig(charge)
      // 重新赋值，因为ChargeUtils.getChargeisOverseaNotControlledByConfig会修改charge.oversea
      charge.oversea = this.billing.billingType === BillingConstants.BILLING_TYPE_OVERSEA.code

      charge.refId = this.autoIncrementNum.getNextNum()
      charge.jobJobNo = this.job.jobNo
      this.showBillEditChargeDialog(charge)
    },
    async editBillCharge() {
      const rows = this.gridApi.getSelectedRows()
      if (rows.length !== 1) {
        this.$message.warning(this.$t('queryJob.PleaseAFeeToEdit'))
        return
      }
      const row = rows[0]
      if (!row._charge && row.uuid) {
        row._charge = await getChargeByUuid(row.uuid).then(res => res.data)
        row.refId = row._charge.refId = this.autoIncrementNum.getNextNum()
      }
      const charge = row._charge
      if (!charge) {
        return
      }
      if (!await ChargeUtils.chargeIsModified({ ...charge, billingUuid: '' }, { uuid: charge.jobUuid })) {
        this.$message.warning(this.$t('queryJob.ThisFeeIsNotEditable'))
        return
      }
      charge.jobJobNo = rows[0].jobJobNo
      this.showBillEditChargeDialog(charge)
    },
    showBillEditChargeDialog(charge) {
      const jobMap = new Map()
      const currencySet = new Set()
      for (const item of this.rowData) {
        if (charge.uuid && charge.uuid === item.uuid) {
          continue
        }
        jobMap.set(item.jobUuid, { uuid: item.jobUuid, jobNo: item.jobJobNo })
        currencySet.add(item.chargeCurrency)
      }
      jobMap.set(charge.jobUuid, { uuid: charge.jobUuid, jobNo: charge.jobJobNo })
      this.billEditChargeDialog.title = charge.uuid ? this.$t('SeaExport.EditCharges') : this.$t('CargoMsg.Cargo_AddCharges')
      this.billEditChargeDialog.simpleJobs = [...jobMap.values()]
      this.billEditChargeDialog.charge = charge
      this.billEditChargeDialog.currencyList = [...currencySet]
      this.billEditChargeDialog.visible = true
    },
    saveBillEditChargeCallback(billCharge) {
      billCharge.refId = billCharge._charge.refId
      this.billDetailHp.editChargeCallBackEvent(billCharge)
    },
    removeBillCharge() {
      const rows = this.gridApi.getSelectedRows()
      if (rows.length === 0) {
        this.$message.warning(this.$t('queryJob.PleaseFeesYouWantDelete'))
        return
      }
      this.$confirm(this.$t('queryJob.AreWantToDeleteExpense'), this.$t('Message.Prompt'), {
        confirmButtonText: this.$t('Message.Confirm'),
        cancelButtonText: this.$t('common.btn.cancel'),
        distinguishCancelAndClose: true,
        type: 'warning'
      }).then(async() => {
        await this.loadJobChargeCache(rows.map(p => p.jobUuid))
        const deleteRows = []
        for (const row of rows) {
          const charge = this.getCharge(row)
          if (!charge) {
            continue
          }
          if (charge.uuid && !await ChargeUtils.chargeIsDeleted({ ...charge, billingUuid: '' }, this.job.lob, this.jobChargeCache)) {
            continue
          }
          deleteRows.push(row)
        }
        if (deleteRows.length === 0) {
          return
        }
        await this.billDetailHp.deleteBillChargeEvent(deleteRows)
      })
    },
    async loadJobChargeCache(jobKeys) {
      for (const jobKey of jobKeys) {
        if (this.jobChargeCache.has(jobKey)) {
          continue
        }
        if (jobKey === this.job.uuid && this.job.charges) {
          this.jobChargeCache.set(jobKey, this.job.charges)
          continue
        }
        const jobModel = await new Job({ uuid: jobKey }).loadJobRelated({ charges: true })
        this.jobChargeCache.set(jobKey, jobModel.charges || [])
      }
    },
    getCharge(row) {
      if (row._charge) {
        return row._charge
      }
      const charges = this.jobChargeCache.get(row.jobUuid)
      return charges?.find(c => c.uuid === row.uuid) || null
    }
  }
}
</script>

<style lang="scss">
#app {
  &.bill-dialog {
    .el-dialog {
      display: flex;
      flex-direction: column;
      overflow: hidden;
    }
    .el-dialog__body{
      flex:1;
      overflow: scroll;
    }
    .el-scrollbar {
      &__view {
        display: flex;
        flex-direction: column;
      }
    }
    &-form-wrapper {
      .el-form-item__content {
        width: auto;
      }
    }
  }
}
</style>
